export default {
    computed: {
        sidebar_context() {
            return this.active_sidebar_context || "portfolio";
        }
    }
};
